import React, { useEffect, useState } from 'react';
import {
  Button,
  Checkbox,
  Col,
  Divider,
  FlexboxGrid,
  IconButton,
  Message,
  Panel,
  Stack,
  toaster,
  Tooltip,
  Uploader,
  Whisper
} from 'rsuite';
import CameraRetroIcon from '@rsuite/icons/legacy/CameraRetro';
import VisibleIcon from '@rsuite/icons/Visible';
import s1 from './templates/s1.jpg';
import globalIP from '@/GlobelIP';
import Resizer from 'react-image-file-resizer';

function previewFile(file, callback) {
  const reader = new FileReader();
  reader.onloadend = () => {
    callback(reader.result);
  };
  reader.readAsDataURL(file);
}

const CataFormat2 = ({ buyertype, buyerName }) => {
  ///// Excel Format Start /////
  const [mainid2, setMainid2] = useState();
  const [buyer2, setBuyer2] = useState('');
  const [fileInfo12, setFileInfo12] = useState({
    BannerPath: null
  });
  const [selectedSlides2, setSelectedSlides2] = useState([]);
  const [cdata2, setCdata2] = useState({
    Banner: 'No',
    Type: '',
    BuyerName: '',
    Body: []
  });
  useEffect(() => {
    setCdata2(prevCdata => ({
      ...prevCdata,
      Type: buyertype,
      BuyerName: buyertype == 'Regular' ? 'N/A' : buyerName
    }));
    setBuyer2(buyertype == 'Regular' ? '' : buyerName);
  }, [buyertype, buyerName]);
  const submit2 = async e => {
    e.preventDefault();
    if (cdata2.Type == 'Buyer') {
      if (cdata2.BuyerName == '' || cdata2.BuyerName == null) {
        toaster.push(
          <Message showIcon type="error">
            Please Select Buyer Name!!!
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        const formData = new FormData();
        if (cdata2.BannerPath) {
          formData.append('files.BannerPath', cdata2.BannerPath);
        }
        const updatedCdata = {
          ...cdata2,
          Body: selectedSlides2.map(slide => ({
            TempName: slide.TempName,
            BuyerName: buyer2
          })) // Ensure proper structure
        };
        formData.append('data', JSON.stringify(updatedCdata));

        let url;
        let method;
        if (mainid2) {
          url = `${globalIP}/api/temp-lib-qtation-excels/${mainid2}`;
          method = 'PUT';
        } else {
          url = `${globalIP}/api/temp-lib-qtation-excels`;
          method = 'POST';
        }

        fetch(url, {
          method: method,
          body: formData
        })
          .then(response => response.json())
          .then(data => {
            console.log(data);
            toaster.push(
              <Message showIcon type="success">
                Saved Successfully
              </Message>,
              { placement: 'topEnd' }
            );
          })
          .catch(error => {
            console.error(error);
            alert('Something went wrong. Please try again');
          });
      }
    } else {
      if (selectedSlides2.length == 0) {
        toaster.push(
          <Message showIcon type="error">
            Please Select Alteast one Body !!!
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        const formData = new FormData();
        if (cdata2.BannerPath) {
          formData.append('files.BannerPath', cdata2.BannerPath);
        }

        const updatedCdata = {
          ...cdata2,
          Body: selectedSlides2.map(slide => ({
            TempName: slide.TempName,
            BuyerName: buyer2
          })) // Ensure proper structure
        };
        formData.append('data', JSON.stringify(updatedCdata));

        let url;
        let method;
        if (mainid2) {
          url = `${globalIP}/api/temp-lib-qtation-excels/${mainid2}`;
          method = 'PUT';
        } else {
          url = `${globalIP}/api/temp-lib-qtation-excels`;
          method = 'POST';
        }
        fetch(url, {
          method: method,
          body: formData
        })
          .then(response => response.json())
          .then(data => {
            console.log(data);
            toaster.push(
              <Message showIcon type="success">
                Saved Successfully
              </Message>,
              { placement: 'topEnd' }
            );
          })
          .catch(error => {
            console.error(error);
            alert('Something went wrong. Please try again');
          });
      }
    }
  };
  const resizeFile = (blobfile) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        blobfile,
        1500,
        1500,
        "JPEG",
        90,
        0,
        (uri) => {
          resolve(uri); // Resolving with the resized Base64 string
        },
        "blob", // Return as base64
        900,
        900
      );
    });
  const handleImageUpload2 = async (fileList, key) => {
    if (fileList.length > 0) {
      const lastIndex = fileList.length - 1;
      const file = fileList[lastIndex];
      const allowedExtensions = ['jpg', 'jpeg'];
      const fileExtension = file.name.split('.').pop().toLowerCase();
      const newfile = await resizeFile(file.blobFile)

      if (allowedExtensions.includes(fileExtension)) {
        setCdata2({
          ...cdata2,
          [key]: newfile
        });
        toaster.push(
          <Message showIcon type="success">
            Image Upload Successfully
          </Message>,
          { placement: 'topCenter' }
        );
        previewFile(newfile, value => {
          setFileInfo12(prev => ({ ...prev, [key]: value }));
        });
      } else {
        toaster.push(
          <Message showIcon type="error">
            Please Change Image should be jpg/jpeg
          </Message>,
          { placement: 'topCenter' }
        );
      }
    }
  };
  useEffect(() => {
    fetchData2();
  }, [buyertype, buyerName]);
  const fetchData2 = async () => {
    try {
      let url;
      if (buyertype == 'Regular') {
        url = `${globalIP}/api/temp-lib-qtation-excels?populate=*&filters[Type][$eq]=${buyertype}`;
      } else {
        url = `${globalIP}/api/temp-lib-qtation-excels?populate=*&filters[Type][$eq]=${buyertype}&filters[BuyerName][$eq]=${buyerName}`;
      }
      const response = await fetch(url);
      const json = await response.json();
      setMainid2(json.data[0]?.id);
      const fetchedSlides = json.data[0]?.attributes?.Body || [];
      setFileInfo12(prev => ({
        ...prev,
        BannerPath: `${globalIP}${json.data[0]?.attributes?.BannerPath?.data?.attributes?.url ?? ''
          }`
      }));
      setCdata2(prev => ({
        ...prev,
        Banner: json.data[0]?.attributes?.Banner ?? 'No',
        Body: fetchedSlides
      }));
      setSelectedSlides2(fetchedSlides);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const handleCheckboxChange12 = (key, checked) => {
    setCdata2({
      ...cdata2,
      [key]: checked ? 'Yes' : 'No'
    });
  };
  const slides2 = [
    { TempName: 'Format F1', BuyerName: '' },
    { TempName: 'Format F2', BuyerName: '' },
    { TempName: 'Format F3', BuyerName: '' }
  ];
  const handleCheckboxChange112 = (slide, checked) => {
    if (checked) {
      setSelectedSlides2(prev => [...prev, slide]);
    } else {
      setSelectedSlides2(prev => prev.filter(s => s.TempName !== slide.TempName));
    }
  };
  ///// Excel Format End /////

  return (
    <Panel bordered>
      <Stack justifyContent="flex-end">
        <Button appearance="primary" color="cyan" onClick={submit2}>
          Save
        </Button>
      </Stack>
      <Stack>
        <b style={{ marginBottom: '5px' }}>Banner</b>
        <Checkbox
          checked={cdata2.Banner === 'Yes'}
          onChange={(value, checked) => handleCheckboxChange12('Banner', checked)}
        />
      </Stack>
      <Panel bordered>
        <Stack direction="column">
          <p style={{ color: 'red' }}>Approx. dimension 1000 x 120 px</p>
          <Uploader
            onChange={e => handleImageUpload2(e, 'BannerPath')}
            fileListVisible={false}
            accept="image/jpeg,image/jpg"
            listType="picture"
            action={''}
          >
            <button style={{ width: 1000, height: 120 }}>
              {fileInfo12.BannerPath ? (
                <img src={fileInfo12.BannerPath} width="100%" height="100%" />
              ) : (
                <CameraRetroIcon style={{ fontSize: 80 }} />
              )}
            </button>
          </Uploader>

          <Whisper speaker={<Tooltip>View Sample</Tooltip>}>
            <IconButton
              icon={<VisibleIcon />}
              size="sm"
              active
            // onClick={() => handleOpen(fileInfo1.PPT_coverpage)}
            />
          </Whisper>
        </Stack>
      </Panel>
      <Stack>
        <b>Body</b>
        <p style={{ color: 'red' }}>*</p>
      </Stack>
      <Divider style={{ marginTop: '5px' }} />
      <FlexboxGrid style={{ textAlign: 'center', marginBottom: '20px' }}>
        {slides2.map(slide => (
          <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '5px' }}>
            <Panel bordered>
              <Stack direction="column">
                <img src={s1} style={{ width: '50%', height: '50%' }} />
                <Stack>
                  <Whisper speaker={<Tooltip>View Sample</Tooltip>}>
                    <IconButton
                      icon={<VisibleIcon />}
                      size="sm"
                      active
                    // onClick={() => handleOpen(fileInfo1.PPT_coverpage)}
                    />
                  </Whisper>
                  <Checkbox
                    checked={selectedSlides2.some(s => s.TempName === slide.TempName)}
                    onChange={(value, checked) => handleCheckboxChange112(slide, checked)}
                  >
                    {slide.TempName}
                  </Checkbox>
                </Stack>
              </Stack>
            </Panel>
          </FlexboxGrid.Item>
        ))}
      </FlexboxGrid>
    </Panel>
  );
};

export default CataFormat2;
